class Backbone.Enhanced.ObjectHasAttributes
  ATTRIBUTES: {}

  constructor: (attributes)->
    if typeof(@ATTRIBUTES) != 'undefined'
      class_attributes = _.clone(
        if typeof(@ATTRIBUTES) == 'function'
          this.ATTRIBUTES.apply(this, arguments)
        else
          @ATTRIBUTES
      )
      config.apply(this, [class_attributes])
    config.apply(this, [attributes])

  config = (options)->
    @_attributes = @_attributes || {}
    for own key, value of options
      @_attributes[key] = value

  get: (name)->
    @_attributes[name]

  getAttributes: ->
    @_attributes

  set: (name, value, options)->
    options = _.extend({silent: false}, options)
    if _.isString(name) and typeof(name.trim) == 'function'
      name = name.trim()

    if _.isString(name) and name.length > 0 and typeof(value) != 'undefined'
      was = @_attributes[name]
      @_attributes[name] = value
      if was != value and typeof(@trigger) == 'function' and ! options.silent
        @trigger("#{name}:change", {prevVal: was, newVal: value}) # Legacy Event
        @trigger("change:#{name}", this, value, {prevVal: was, newVal: value}) # Backbone Mimic
    this

  setAttributes: (object, options)->
    for key, value of object
      @set(key, value, options)
    this

  toJSON: ->
    JSON.stringify @getattributes()

  removeAttribute: (key)->
    delete @_attributes[key]
    this

module.exports = Backbone.Enhanced.ObjectHasAttributes